import { render, staticRenderFns } from "./ShowCompaniesForm.vue?vue&type=template&id=145c9cfc&scoped=true&"
import script from "./ShowCompaniesForm.vue?vue&type=script&lang=ts&"
export * from "./ShowCompaniesForm.vue?vue&type=script&lang=ts&"
import style0 from "./ShowCompaniesForm.vue?vue&type=style&index=0&id=145c9cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c9cfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
